// extracted by mini-css-extract-plugin
module.exports = {"transactionsCard":"AccountScreen_transactionsCard__2kgw8"};